// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cryptography-policy.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cryptography-policy',
  title: 'Verify cryptography policy and key management',
  description:
    'Confirm that rules for cryptographic use and key management are documented and published.',
  category: 'technical',
  scfIds: ['SCF-NET-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Cryptography policy is published' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
